let version = 'v2'

if (window.location.host.includes('stage')){
	version = 'stage'
}

if (window.location.host.includes('local')){
	// version = 'stage'
}

const apiURL = `https://api.buddy.hr/${version}`;
// const apiURL = `http://localhost:3000`;

console.log('apiURL',apiURL)

// export default apiURL;
module.exports = apiURL